import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { fetchDashboardStats, fetchDashboardTrends } from './dashboard-operations';

interface DashboardState {
  stats: any;
  trends: any;
  isLoading: boolean;
  error: string | null;
}

const initialState: DashboardState = {
  stats: null,
  trends: null,
  isLoading: false,
  error: null,
};

const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchDashboardStats.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchDashboardStats.fulfilled, (state, action: PayloadAction<any>) => {
        state.isLoading = false;
        state.stats = action.payload;
        state.error = null;
      })
      .addCase(fetchDashboardStats.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload as string;
      })
      .addCase(fetchDashboardTrends.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchDashboardTrends.fulfilled, (state, action: PayloadAction<any>) => {
        state.isLoading = false;
        state.trends = action.payload;
        state.error = null;
      })
      .addCase(fetchDashboardTrends.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload as string;
      });
  },
});

export default dashboardSlice.reducer;
